import { css, type Theme } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";
import * as helpers from "@styles/emotion-styles/helpers";

export const button = (theme: Theme) => css`
  border-radius: ${dimensions.pillBorderRadius};
  padding: 0;
  margin-left: 0.25rem;
  margin-bottom: 0.25rem;
  &:hover,
  &:active,
  &:focus {
    border-color: ${theme.primary.borderHover};
    box-shadow: 0 1px 2px 0 ${helpers.hexToRgba(theme.text.body, 0.25)};
  }

  @media only screen and (max-width: ${dimensions.phoneMax}) {
    font-size: 0.75rem;
    height: 1.5rem;
  }
`;

export const icon = (theme: Theme) => css`
  path {
    fill: ${theme.success.textBase};
  }
`;

export const iconContainer = (theme: Theme) => css`
  height: calc(2.25rem - 0.125rem);
  width: calc(2.25rem - 0.125rem);
  border-radius: ${dimensions.circleRadius};
  background-color: ${theme.system.backgroundMuted};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.success.textBase};
  @media only screen and (max-width: ${dimensions.phoneMax}) {
    display: none;
  }
`;

export const label = css`
  margin: 0 0.5rem;
  padding-right: 0.333rem;
`;
